import IconButton from 'apollo-react/components/IconButton';
import Tooltip from 'apollo-react/components/Tooltip';
import Pencil from 'apollo-react-icons/Pencil';
import Trash from 'apollo-react-icons/Trash';
import React from 'react';

import withTranslation from '../../../components/withTranslation';

const CustomHeaderActions = ({ tabs, showEdit, showDelete, onEdit, onDelete, translateString }) => (
  <>
    {showEdit && (
      <Tooltip title={translateString(tabs.length === 1 ? 'Edit Part' : 'Edit Tab')}>
        <IconButton
          onClick={onEdit}
          aria-label={translateString(tabs.length === 1 ? 'Edit Part' : 'Edit Tab')}
        >
          <Pencil />
        </IconButton>
      </Tooltip>
    )}
    {showDelete && (
      <Tooltip title={translateString('Delete Part')}>
        <IconButton onClick={onDelete} aria-label={translateString('Delete Part')}>
          <Trash />
        </IconButton>
      </Tooltip>
    )}
  </>
);

export default withTranslation(CustomHeaderActions);
